import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

export const styles = StyleSheet.create({
  lozengeWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20
  },
  lozenge: {
    fontSize: 12,
    color: colour.grey[400],
    border: `1px solid ${colour.grey[500]}`,
    borderRadius: 12,
    padding: '3px 10px'
  }
});
